import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@/components/links';
import { FILES } from '@/constants/files';
import { useRouter } from 'next/router';
export function DoYouKnowMore() {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["extendedWarranty"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("doYouKnowMore.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="w-full"><Image src="/images/sections/extendedWarranty/doYouKnowMore.png" alt={t1} width={600} height={540} className="md:max-w-fullg mx-auto max-w-[90%]" /></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("doYouKnowMore.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <SectionHeadline className="mb-4 lg:text-left" anchorKey="doYouKnowMore.title">{t3}</SectionHeadline>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== locale) {
    t5 = FILES(locale);
    $[9] = locale;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5.insuranceTerms) {
    t6 = <Link analyticsParam="extendedWarrantyConditionals" testId="extendedWarrantyConditionals" to={t5.insuranceTerms} target="_blank" />;
    $[11] = t5.insuranceTerms;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <b className="font-semibold" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t || $[15] !== t6) {
    t8 = <p className="text-center lg:text-left"><Trans t={t} i18nKey="doYouKnowMore.text">{t6}{t7}</Trans></p>;
    $[14] = t;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t8) {
    t9 = <div className="w-full">{t4}{t8}</div>;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t9) {
    t10 = <ContentContainer className="px-4"><div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-32">{t2}{t9}</div></ContentContainer>;
    $[20] = t2;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}